export * from './entity-detail.component';
